import { NavLink } from "react-router-dom";
import logo from "../Header/images/newsmaxplus-logo-2025.svg";
import { HeaderStyled, LogoStyled } from "./HeaderStyled";
import Auth from "./Auth";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import "../../index.css";

const Header = () => {

    return (
        <HeaderStyled isHomePage>
            <div className="container-fluid">
                <nav className="navbar row bg-body-tertiary">
                    <div className="container-fluid">
                        <div>
                            {/*<NavLink to="/">*/}
                            {/*    <LogoStyled src={logo} />*/}
                            {/*</NavLink>*/}
                        </div>
                        <div className={useLocation().pathname === "/winback" ? "hide" : "show"}>
                            <Auth onGiftToggle={() => { }} isGiftMode={false} />
                        </div>
                    </div>
                </nav>
            </div>
        </HeaderStyled>
    );
};

export default Header;
